import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["gates"],
  _excluded2 = ["gates"];
import { Select } from 'foundations-components/transitional/components/Select';
import { DropdownSelect } from 'foundations-components/transitional/components/Dropdown';
import { AccessCheckDropdownShell } from './AccessCheckDropdownShell';
import { AccessCheckDropdownContext } from '../../../../contexts/AccessCheckDropdownContext';
import { useHandleOptionsPropForDropdowns } from './hooks/useHandleOptionsPropForDropdowns';
import { checkSelectOptions } from '../../../../utils/checkSelectOptions';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
function createSelectContentComponent(SelectComponent) {
  return function AccessCheckSelectContent({
    dropdownProps
  }) {
    const options = dropdownProps.options;
    const {
      accessInfoMap,
      isLoading,
      toDisplayDropdown
    } = useHandleOptionsPropForDropdowns(options, checkSelectOptions);
    if (!options) {
      console.error('Select options are required');
      return null;
    }
    if (isLoading) {
      return /*#__PURE__*/_jsx(AccessCheckDropdownContext.Provider, {
        value: {
          accessInfoMap,
          hasAllGates: true
        },
        children: /*#__PURE__*/_jsx(LoadingSpinner, {
          children: /*#__PURE__*/_jsx(SelectComponent, Object.assign({}, dropdownProps))
        })
      });
    }
    const reconstructedOptions = options.map(option => {
      if (option.accessCheckProperties) {
        const accessInfo = option.dropdownItemId ? accessInfoMap.get(option.dropdownItemId) : undefined;
        if (accessInfo !== null && accessInfo !== void 0 && accessInfo.hasAccess) {
          return option;
        } else if (accessInfo !== null && accessInfo !== void 0 && accessInfo.isVisible) {
          return Object.assign({}, option, {
            disabled: true
          });
        } else {
          return null;
        }
      } else {
        return option;
      }
    }).filter(option => option !== null);
    return toDisplayDropdown ? /*#__PURE__*/_jsx(AccessCheckDropdownContext.Provider, {
      value: {
        accessInfoMap,
        hasAllGates: true
      },
      children: /*#__PURE__*/_jsx(SelectComponent, Object.assign({}, dropdownProps, {
        options: reconstructedOptions
      }))
    }) : null;
  };
}
const SelectContent = createSelectContentComponent(Select);
const DropdownSelectContent = createSelectContentComponent(DropdownSelect);
export function AccessCheckSelect(_ref) {
  let {
      gates
    } = _ref,
    selectProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AccessCheckDropdownShell, {
    gates: gates,
    dropdownProps: selectProps,
    DropdownComponent: Select,
    ContentComponent: SelectContent
  });
}
export function AccessCheckDropdownSelect(_ref2) {
  let {
      gates
    } = _ref2,
    selectProps = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(AccessCheckDropdownShell, {
    gates: gates,
    dropdownProps: selectProps,
    DropdownComponent: DropdownSelect,
    ContentComponent: DropdownSelectContent
  });
}